const splitNameParts = (name: string): string[] =>
  name.split(' ').filter((part) => part.length > 0);

export const getNameInitials = (name: string): string => {
  const parts = splitNameParts(name);

  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();

  const first = parts[0].charAt(0);
  const last = parts[parts.length - 1].charAt(0);

  return `${first}${last}`.toUpperCase();
};

export const formatShortName = (name: string): string => {
  const parts = splitNameParts(name);

  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];

  return `${parts[0]} ${parts[parts.length - 1]}`;
};
